import { post, get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";
import { serialize } from "./visits-logging.serializer";

export const getCurrentSessionInformation = async (
  token: string,
  baseUrl: string
): Promise<any> => {
  const queryPath = `${baseUrl}/session_info`;
  try {
    const res = await get(token, queryPath);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const postVisitInfo = async (
  token: string,
  baseUrl: string,
  body: any
): Promise<any> => {
  const queryPath = `${baseUrl}/logger`;
  try {
    const serializedBody = await serialize(body);
    const res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
